import * as React from 'react';

import classnames from 'classnames';

// @ts-expect-error - imported from .js/.jsx file
import {PlusThinIcon} from 'shells/icon/svg/plus-thin-icon';

type Props = {
    onClick: () => any;
    isActive: boolean;
    buttonRef: any;
};

export function AddNewButton(props: Props) {
    return (
        <button
            className={classnames('nut-navbar--create-button', {
                'nut-navbar--create-button--active': props.isActive,
            })}
            ref={props.buttonRef}
            onClick={props.onClick}
        >
            <PlusThinIcon size={14} alignCenter={true} />
            Add new
        </button>
    );
}
